<!--
CREATE TABLE `pos_payment_log` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `pos_id` int(11) DEFAULT NULL COMMENT 'pos机',
  `send_context` text COLLATE utf8mb4_bin COMMENT '请求参数',
  `result_context` text COLLATE utf8mb4_bin COMMENT '响应参数',
  `request_code` int(11) DEFAULT NULL COMMENT '请求ID',
  `is_result` tinyint(1) DEFAULT '0' COMMENT '是否返回：0未返回，1已返回',
  `from_type` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '请求来源',
  `payment_type` varchar(10) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '支付来源',
  `batch_number` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '业务批次号',
  `create_time` datetime DEFAULT NULL COMMENT '创建时间',
  `update_time` datetime DEFAULT NULL COMMENT '修改时间',
  PRIMARY KEY (`id`),
  KEY `pos_id` (`pos_id`),
  KEY `request_code` (`request_code`),
  KEY `is_result` (`is_result`),
  KEY `from_type` (`from_type`),
  KEY `batch_number` (`batch_number`),
  KEY `payment_type` (`payment_type`)
) ENGINE=InnoDB AUTO_INCREMENT=195188 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_bin;
-->
<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-input v-model="query.pos_id" placeholder="POS机ID" size="mini" style="width:150px" />
      <el-input v-model="query.payment_type" placeholder="支付来源" size="mini" style="width:150px" />
      <el-input v-model="query.from_type" placeholder="请求来源" size="mini" style="width:150px" />
      <el-button type="primary" @click="getList" size="mini">搜索</el-button>
    </div>

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="70" fixed />
      <el-table-column prop="pos_id" label="POS机ID" width="90" />
      <el-table-column prop="request_code" label="请求ID" width="100" />
      <el-table-column prop="is_result" label="是否返回" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_result===1" type="success">已返回</el-tag>
          <el-tag v-else type="warning">未返回</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="from_type" label="请求来源" width="120" show-overflow-tooltip />
      <el-table-column prop="payment_type" label="支付来源" width="100" />
      <el-table-column prop="batch_number" label="业务批次号" width="140" show-overflow-tooltip />
      <el-table-column prop="send_context" label="请求参数" width="200" show-overflow-tooltip />
      <el-table-column prop="result_context" label="响应参数" width="200" show-overflow-tooltip />
      <el-table-column prop="create_time" label="创建时间" width="150" />
      <el-table-column prop="update_time" label="修改时间" width="150" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next,sizes"
      :total="pageData.total"
      :page-sizes="[10, 20, 50, 100]"
      style="margin-top:15px;text-align:right"
    />
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'PaymentLog',
  data() {
    return {
      query: {
        pos_id: "",
        payment_type: "",
        from_type: "",
      },
      pageData: {
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      const params = Params.ins()
        .where(this.query.pos_id ? ['pos_id', '=', this.query.pos_id] : null)
        .where(this.query.payment_type ? ['payment_type', '=', this.query.payment_type] : null)
        .where(this.query.from_type ? ['from_type', '=', this.query.from_type] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('PaymentLog/index', params, res => {
        if (res.code === 200) {
          this.pageData = res.data
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },
    sizeChange(size) {
      this.pageData.size = size
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body {
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/PosDevice/PaymentLog.vue